<template>

    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Video Approval</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4">

                <div class="flex items-center bg-red-700 text-white text-sm font-bold px-4 py-3 mb-4" role="alert" v-if="data.embargo !== null">
                    <p><i class="fas fa-exclamation-triangle mr-2"></i> There is an embargo for this video in the <strong>{{ data.embargo }}</strong> market.</p>
                </div>

                <YouTubePlayer :youtube_id="data.youtube_id" />

                <p class="pt-5"><strong>Direct YouTube Preview: </strong><br /> <a class="text-blue-600" :href="'https://youtube.com/watch?v=' + data.youtube_id" target="_blank">https://youtube.com/watch?v={{ data.youtube_id }}</a></p>

                <p class="pt-5"><strong>Content Raiting: </strong><br /> <StarRating :id="data.id" :rating="data.rating" /></p>

                <p class="pt-5"><strong>Description: </strong><br /> {{ data.description }}</p>

                <p class="pt-5"><strong>Credit: </strong><br /> {{ data.user_credit }} / Viral News</p>

                <p class="pt-5"><strong>Locations: </strong><br /> <span class="px-2 py-1 text-xs text-white  bg-green-600 rounded mr-2" v-for="location in data.locations">{{ location }}</span></p>

                <p class="pt-5"><strong>Tags: </strong><br /> <span class="px-2 py-1 text-xs text-white bg-blue-700 rounded mr-2" v-for="tag in data.tags">{{ tag }}</span></p>

                <p class="pt-5 text-center"><small class="text-sm text-blue-600 cursor-pointer" v-on:click="showPricingDialog()">Pricing different then what you were expecting?</small></p>
            </div>

            <!-- footer -->
            <div class="mt-10 clearfix">
                <!-- @click="addAnnouncement()" -->
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Close
                </button>
                <button v-on:click="purchase" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Purchase Video
                </button>
            </div>

        </div>
    </Modal>

</template>

<script>
    import { EventBus } from '@/utils/events'
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex'
    import moment from 'moment';
    import YouTubePlayer from '@/components/media/components/YouTubePlayer'

    import Modal from '@/components/Modal'
    import StarRating from '@/components/general/StarRating'

    export default {
        data() {
            return {
                displayModal: false,
                modal: false,
                data: {},
                price: null,
                visibility: 'public',
                playlists: [],
                players: null,
                embargo: null,
            }
        },

        components: {
            Modal,
            YouTubePlayer,
            StarRating
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('media-view-video-open-modal', this.open)
            }.bind(this))
        },

        destroyed() {
            EventBus.$off('media-view-video-open-modal', this.open)
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            open(data) {
                this.displayModal = true
                this.data = data;
                this.user = this.data.user;
            },

            purchase() {

                var _this = this;

                this.$swal({
                    title: 'Continue?',
                    text: "You are about to purchase " + this.data.title + " for $" + this.data.price + ".",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, purchase and download.'
                }).then((result) => {

                    if (result.value) {

                        var data = {
                            id: this.data.id,
                        }

                        this.$http.post(Config.apiPath + "/api/v2/media/purchases/new", data, this.getAuthorizationHeader())
                            .then((response) => {
                                
                                var link = document.createElement('a');
                                document.body.appendChild(link);
                                link.href = response.data;
                                link.click();
                                document.body.removeChild(link);

                                _this.$swal(
                                    'All good!',
                                    'The video download has started.',
                                    'success'
                                )

                                EventBus.$emit('media-video-refresh-data');
                                _this.displayModal = false

                            });
                    }

                });

            },

            showPricingDialog() {
                this.$swal(
                    '',
                    "Any external pricing agreements will be applied after content is downloaded. For immediate questions regarding pricing, please call Brett Adair directly by dialing (256) 267-7747.",
                    "info"
                );
            },

        }
        
    }
</script>